import Burn from '../views/Burn'

export default Burn
